module.exports = __webpack_public_path__ + "img/kcszzypt.95f5bc41.png";